const en_US = {
	WIN_TITLE: "NES Emulator ({0} FPS)",
	
	MENU_FILE: "File",
	MENU_EMULATION: "Emulation",
	
	FILE_OPEN: "Open",
	FILE_QUIT: "Quit",
	
	EMULATION_RESET: "Reset",
	EMULATION_STEP: "Step",
	EMULATION_CYCLE: "Cycle",
	EMULATION_STOP: "Stop",
	EMULATION_RESUME: "Resume",
	EMULATION_AUDIO_DISABLE: "Disable Audio",
	EMULATION_AUDIO_ENABLE: "Enable Audio"
};

module.exports = {en_US};
